module.exports = __webpack_public_path__ + "static/media/bouquet-sm.9024f678.svg";